import Vue from 'vue';
import router from './router';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ja';

// amplify
import awsconfig from './aws-exports';
import Amplify, * as AmplifyModules from 'aws-amplify';
//import { AmplifyPlugin } from 'aws-amplify-vue';
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';
Amplify.configure(awsconfig);
Vue.use(AmplifyModules);

applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.ignoredElements = [/amplify-\w*/];

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });

import VueGtag from 'vue-gtag'

import VueHead from 'vue-head'
Vue.use(VueHead)

// 多言語対応
let languageDict = {
  ja:{
      // タイトル
      'Sign in to your account' : 'ログイン',
      'Create a new account': 'アカウントの新規作成',
      'Reset your password': 'パスワードのリセット',
      'Confirm Sign Up': 'メールアドレスの認証',
      'Confirm Sign up': 'メールアドレスの認証',
      // 入力項目
      'Username' : 'アカウント名(メールアドレス)',
      'Username *' : 'アカウント名(メールアドレス)',
      'Email' : 'メールアドレス',
      'Enter your Email' : 'メールアドレスを入力してください',
      'Enter your username' : 'アカウント名(メールアドレス)を入力してください',
      'Enter your code' : 'メールで届いた認証コードを入力してください',
      'Name' : '名前',
      'Password *' : 'パスワード(8文字以上、小文字・数字の両方を含む)',
      'Enter your password' : 'パスワードを入力してください',
      'Code': '認証コード',
      'New Password': '新しいパスワード',
      'Confirmation Code': '認証コード',
      'Enter your Username': 'アカウント名(メールアドレス)を入力してください',
      // 注釈
      'Forget your password? ' : 'パスワードを忘れた場合',
      'Forgot your password? ' : 'パスワードを忘れた場合',
      'Forgot your password?' : 'パスワードを忘れた場合',
      'No account? ' : ' ', // 半角スペース1個必須
      'No account?' : ' ', // 半角スペース1個必須
      'Have an account? ': ' ', // 半角スペース1個必須
      'Have an account?': ' ', // 半角スペース1個必須
      'Lost your code? ': 'メールアドレスに認証コードが届かない場合',
      'Lost your code?': '認証コードのメールが届かない場合',
      // ボタン
      'Back to Sign In': 'ログインに戻る',
      'Resend Code': '認証コードの再送信',
      'Reset password' : 'パスワードのリセット',
      'Sign in' : ' ',
      'Sign In' : 'ログイン',
      'Sign Out' : 'ログアウト',
      'Create account' : ' ',
      'Create Account' : 'アカウント作成',
      'Send Code': '次へ進む',
      'Submit': '送信',
      'Confirm': '登録完了',
      // エラーコード
      'Username cannot be empty': 'アカウント名(メールアドレス)を入力してください',
      'null failed with error Generate callenges lambda cannot be called..': 'パスワードを入力してください',
      'Incorrect username or password.': 'アカウント名(メールアドレス)もしくはパスワードが正しくありません',
      'Username/client id combination not found.': 'アカウント名(メールアドレス)が正しくありません',
      'Invalid verification code provided, please try again.': '認証コードが正しくありません',
      'Password reset required for the user': 'パスワードを再設定してください',
      'User does not exist.': 'アカウント名(メールアドレス)を確認してください',
      'Custom auth lambda trigger is not configured for the user pool.': 'パスワードを入力してください',
      'User is not confirmed.': 'アカウント名(メールアドレス)は検証されていません',
      'User already exists': 'アカウント名(メールアドレス)は既に存在します',
      'Invalid password format': 'パスワードのフォーマットが不正です',
      'Account recovery requires verified contact information': 'アカウントの復元には確認済みの連絡先情報が必要です',
      'Invalid phone number format':'不正な電話番号フォーマットです。 電話番号は次のフォーマットで入力してください: +12345678900',
      'An account with the given email already exists.': 'そのメールアドレスは既に存在します',
      'Password attempts exceeded': 'パスワード試行回数が超過しました',
      'Attempt limit exceeded, please try after some time.': '試行制限を超過しました。しばらくしてからもう一度お試しください',
      'The following fields must be completed: Username': 'アカウント名(メールアドレス)を入力してください',
      'The following fields must be completed: Password': 'パスワードを入力してください',
      'The following fields must be completed: Username, Password': 'アカウント名(メールアドレス)とパスワードを入力してください',
      'Username should be an email.': 'アカウント名(メールアドレス)が正しくありません',
      "1 validation error detected: Value at 'username' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+":
        'アカウント名(メールアドレス)が正しくありません',

      'CUSTOM_AUTH is not enabled for the client.': 
        'パスワードは必須です', // 本来の意味とは異なるが、パスワード未入力時に発生するのでこの訳としている
      
      'Password does not conform to policy: Password not long enough':
        'パスワードは8文字以上の長さが必要です (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      'Password did not conform with policy: Password not long enough':
         'パスワードは8文字以上の長さが必要です (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      
      'Password does not conform to policy: Password must have uppercase characters':
         'パスワードには大文字を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      'Password did not conform with policy: Password must have uppercase characters':
         'パスワードには大文字を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正

      'Password does not conform to policy: Password must have lowercase characters':
        'パスワードには小文字を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      'Password did not conform with policy: Password must have lowercase characters':
        'パスワードには小文字を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      
      'Password does not conform to policy: Password must have numeric characters':
        'パスワードには数字を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      'Password did not conform with policy: Password must have numeric characters':
        'パスワードには数字を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      
      'Password does not conform to policy: Password must have symbol characters':
        'パスワードには記号を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正
      'Password did not conform with policy: Password must have symbol characters':
        'パスワードには記号を含めてください (8文字以上で、半角の小文字・数字の両方を含む必要があります)', // 適宜修正

      "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
        'パスワードは8文字以上で、半角の小文字・数字の両方を含む必要があります', // 適宜修正。本来の意味とは異なるがこれで明示している。
      "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[S]+.*[S]+$":
        'パスワードは8文字以上で、半角の小文字・数字の両方を含む必要があります', // 適宜修正。本来の意味とは異なるがこれで明示している。
      "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$":
        'パスワードは8文字以上で、半角の小文字・数字の両方を含む必要があります', // 適宜修正。本来の意味とは異なるがこれで明示している。
      "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256":
        'パスワードは256文字以下にしてください',
      "1 validation error detected: Value at 'username' failed to satisfy constraint: Member must have length less than or equal to 128":
        'アカウント名(メールアドレス)は128文字以下にしてください',

      // ref: https://github.com/aws-amplify-jp/vocabulary-ja/blob/main/locale/ja.js
      'Verification code': '認証コード',
      'Enter code': 'メールで届いた認証コードを入力してください',
      'New password': '新しいパスワード(8文字以上、小文字・数字の両方を含む)',
      'Enter your new password': '新しいパスワードを入力してください',

  }
}
AmplifyModules.I18n.putVocabularies(languageDict)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');


let gaId = 'G-LTG1ZH574V'
let hostname = location.hostname

// 専用環境用のGA
if (/*住友環境用*/
    /*hostname === 'localhost' // 開発案件に応じて変更
    ||*/ hostname === 'devsl.d2q78m2xs8yfz1.amplifyapp.com'
    || hostname === 'sl.d2q78m2xs8yfz1.amplifyapp.com'
    || hostname === 'sumitomolife.cancerwith.com') {
  gaId = 'G-ZBLCZQXSGK'
} else if (/*大阪環境用*/
    /*hostname === 'localhost' // 開発案件に応じて変更
    ||*/ hostname === 'devosaka.d2q78m2xs8yfz1.amplifyapp.com'
    || hostname === 'osaka.d2q78m2xs8yfz1.amplifyapp.com'
    || hostname === 'aya.cancerwith.com') {
  gaId = 'G-ZRV5VG5C1X'
} else if (/*浜松環境用*/
  hostname === 'localhost' // 開発案件に応じて変更
    || hostname === 'devhama.d2q78m2xs8yfz1.amplifyapp.com'
    || hostname === 'hama.d2q78m2xs8yfz1.amplifyapp.com'
    || hostname === 'hama.cancerwith.com') {
gaId = 'G-SBRSWY6T87'
}

Vue.use(VueGtag, {
  config: {
    id: gaId,
    params: {
      send_page_view: false
    }
  }
}, router);
